import { render, staticRenderFns } from "./ImportFromProject.vue?vue&type=template&id=47f377ff&scoped=true"
import script from "./ImportFromProject.vue?vue&type=script&lang=js"
export * from "./ImportFromProject.vue?vue&type=script&lang=js"
import style0 from "./ImportFromProject.vue?vue&type=style&index=0&id=47f377ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f377ff",
  null
  
)

export default component.exports